import { render, staticRenderFns } from "./BoosterMiniature.vue?vue&type=template&id=b8c36f68&"
import script from "./BoosterMiniature.vue?vue&type=script&lang=js&"
export * from "./BoosterMiniature.vue?vue&type=script&lang=js&"
import style0 from "./BoosterMiniature.vue?vue&type=style&index=0&id=b8c36f68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports